import { useEffect, useState } from "react";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
// import { Document, Page } from "react-pdf"; // For PDF preview, use react-pdf

const WordInputField = ({
  name,
  multiple = false,
  maxFiles,
  register,
  setValue,
  watch,
  accept = ".pdf, .doc, .docx",
  label,
}) => {
  const [filesPreview, setFilesPreview] = useState([]);
  const watchedFiles = watch(name) ? watch(name) : [];

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const currentFiles = watchedFiles;

    if (currentFiles.length + files.length > maxFiles) {
      alert(`You can only upload a maximum of ${maxFiles} files.`);
      return;
    }

    const filePreviews = files.map((file) => ({
      name: file.name,
      url: URL.createObjectURL(file),
      type: file.type,
    }));

    setFilesPreview((prevFiles) => [...prevFiles, ...filePreviews]);
    setValue(name, [...currentFiles, ...files]); // Set the files in the form state
  };

  const handleRemoveFile = (index) => {
    const updatedPreviews = filesPreview.filter((_, i) => i !== index);
    const updatedFiles = watch(name).filter((_, i) => i !== index);

    setFilesPreview(updatedPreviews);
    setValue(name, updatedFiles); // Update the form state
  };

  useEffect(() => {
    if (Array.isArray(watchedFiles) && watchedFiles.length > 0) {
      const filePreviews = watchedFiles.map((file) => ({
        name: file.name,
        url: URL.createObjectURL(file),
        type: file.type,
      }));
      setFilesPreview(filePreviews);
    } else {
      setFilesPreview([]); // Clear previews if no files are present
    }
  }, [watchedFiles]);

  // const newFiles = filesPreview.map((item) => {
  //   return { name: item.name, uri: item.url, type: item.type };
  // });
  return (
    <div>
      <label
        htmlFor={name}
        className="cursor-pointer text-text-1/90 bg-bkg2 p-2 text-center hover:text-text-1/60"
      >
        {label}
      </label>
      <span>
        {" "}
        Max of {maxFiles} {name}
      </span>
      <input
        id={name}
        type="file"
        accept={accept} // Restrict to PDF, DOC, and DOCX
        multiple={multiple}
        {...register(name)}
        onChange={handleFileChange}
        className="mb-4 invisible"
        disabled={filesPreview.length >= maxFiles}
      />

      <div className="flex flex-wrap gap-4">
        {filesPreview.map((file, index) => (
          <div key={index} className="relative">
            {/* Render a PDF viewer for PDFs, or use Google Docs Viewer for Word files */}
            {file.type === "application/pdf" ? (
              <div className="w-32 h-32 overflow-auto bg-bkg2 rounded">
                {/* Display a PDF */}
                <embed
                  src={file.url}
                  width="100%"
                  height="100%"
                  type="application/pdf"
                  style={{ pointerEvents: "none" }}
                />
              </div>
            ) : file.type.includes("word") ||
              file.name.endsWith(".doc") ||
              file.name.endsWith(".docx") ? (
              <div className="w-32 h-32 overflow-auto bg-bkg2 rounded">
                {/* Display Word file using Google Docs Viewer */}
                <iframe
                  src={file.url}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                ></iframe>
              </div>
            ) : (
              <div className="p-2 bg-bkg2 text-center w-32 h-32 flex flex-col justify-center items-center rounded">
                <p className="text-sm font-medium">{file.name}</p>
                <p className="text-xs text-gray-500">{file.type}</p>
                {/* <a
                  href={file.url}
                  download={file.name}
                  className="text-blue-500 underline mt-1"
                >
                  Download
                </a> */}
              </div>
            )}

            {/* Remove button */}
            <button
              onClick={() => handleRemoveFile(index)}
              type="button"
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 text-center text-xs"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WordInputField;
